import styled from 'styled-components';

import {
  Text,
  TextArea,
  RadioGroup,
  Button as YogaButton,
} from '@gympass/yoga';
import { AlertTriangle } from '@gympass/yoga-icons';

import { Button } from '../../components/Button';

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  justify-items: start;
  gap: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  text-align: left;
  width: ${({ theme }) => theme.yoga.sizes.notesModalWidth}px;
`;

export const FormHeader = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const Title = styled(Text.H5)`
  width: 100%;
`;

export const Alert = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: start;
`;

export const AlertIcon = styled(AlertTriangle).attrs({
  width: '20',
  height: '20',
})`
  margin-right: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  fill: ${({ theme }) => theme.yoga.colors.error};
`;

export const AlertMessage = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.error};
`;

export const DischargeBody = styled.div`
  display: grid;
  gap: 18px;
`;

export const Instruction = styled(Text.Medium)`
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  color: ${({ theme }) => theme.yoga.colors.textSecondary};
`;

export const Radios = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  width: 100%;
`;

export const RadioItem = styled.label<{ disabled?: boolean }>`
  display: flex;
  width: 100%;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const Radio = styled(RadioGroup.Radio)`
  margin-right: 10px;
`;

export const RadioText = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.textSecondary};
`;

export const Description = styled(TextArea)``;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  align-items: center;
`;

export const CancelButton = styled(YogaButton.Link)`
  color: ${({ theme }) => theme.yoga.colors.primary};
`;

export const SendButton = styled(props => <Button {...props} />)`
  color: white;
`;
